import React from 'react'
import { useToast } from 'src/utils/toast'
import {
  useFindOrCreateTenantConfiguration,
  useGetTenantConfigurables,
  useUpdateTenantConfiguration,
} from 'src/api/queries/microservices/tenant-config'
import ConfigurationPanel from 'src/components/configuration-panel/ConfigurationPanel'

type TenantConfigPanelProps = {
  baseUri: string
  title?: string
  editPermission?: string
  alwaysExpanded?: boolean
}

export default function TenantConfigPanel({
  title,
  baseUri,
  editPermission = 'company_properties_edit',
  alwaysExpanded = false,
}: Readonly<TenantConfigPanelProps>) {
  const toast = useToast()
  const { data: configurables } = useGetTenantConfigurables(baseUri)
  const { data: tenantConfig } = useFindOrCreateTenantConfiguration(baseUri)
  const { mutateAsync: updateConfig } = useUpdateTenantConfiguration(baseUri)

  const onSave = async (updateData: KeyValuePair[]) => {
    await updateConfig({ configurations: updateData })
    toast({ title: 'Success', description: `Updated ${title ?? 'tenant'} configuration` })
  }

  return (
    <ConfigurationPanel
      title={title}
      configurations={configurables}
      data={tenantConfig}
      onSave={onSave}
      editPermission={editPermission}
      alwaysExpanded={alwaysExpanded}
    />
  )
}
